document.addEventListener('DOMContentLoaded', function() {
  // GA4 Signup Tracking
  (function() {
    var thanksPage = document.querySelector('.sb-signup-thanks[data-signup-type]');

    if (!thanksPage) return;

    var signupType = thanksPage.getAttribute('data-signup-type');

    function trackSignup(attemptsLeft) {
      if (typeof gtag === 'function') {
        gtag('event', 'signup', { signup_type: signupType });
        return;
      }

      if (attemptsLeft > 0) {
        setTimeout(function() {
          trackSignup(attemptsLeft - 1);
        }, 500);
      }
    }

    trackSignup(10);
  })();

  document.querySelectorAll('.sb-form').forEach(function(form) {
    var startField = form.querySelector('.sb-form-start');
    var submitButton = form.querySelector('.sb-submit');

    if (startField) {
      startField.value = Date.now();
    }

    form.addEventListener('submit', function(event) {
      if (form.classList.contains('is-submitting')) {
        event.preventDefault();
        return;
      }

      var email = form.querySelector('input[name="EMAIL"]');
      var honey = form.querySelector('input[name="WEBSITE"]');
      var existingError = form.querySelector('.sb-form-error');
      var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      var started = startField ? parseInt(startField.value, 10) : Date.now();
      var elapsed = Date.now() - started;
      var redirectUrl = form.getAttribute('data-redirect');

      if (existingError) {
        existingError.remove();
      }

      if ((honey && honey.value) || elapsed < 2000) {
        event.preventDefault();
        return;
      }

      if (!email || !emailPattern.test(email.value.trim())) {
        event.preventDefault();

        var error = document.createElement('p');
        error.className = 'sb-form-error';
        error.textContent = 'Please enter a valid email address.';
        form.appendChild(error);

        if (email) {
          email.focus();
        }

        return;
      }

      form.classList.add('is-submitting');

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Submitting...';
      }

      if (redirectUrl) {
        setTimeout(function() {
          window.location.href = redirectUrl;
        }, 1800);
      }
    });
  });
});